<div class="d-flex align-items-center marginLeftDateAndTime theme-interface">
  <div class="d-flex align-items-center my-n3">
    <!-- Hidden app-date-picker: the toggle below opens its calendar overlay
         programmatically; the internal control mirrors the displayed date. -->
    <app-date-picker
      [hiddenTrigger]="true"
      [control]="dateControl"
    ></app-date-picker>
    <mat-datepicker-toggle
      matSuffix
      class="theme-color-date-icon"
      data-testid="datepicker-toggle"
      (click)="openPicker()"
    ></mat-datepicker-toggle>
  </div>
  <div class="d-flex align-items-center">
    <div class="d-flex dateSelector">
      <div
        class="d-flex px-2 px-sm-1 arrow down m-auto"
        (click)="decrementDate()"
      >
        <i class="fas fa-chevron-left theme-color-header"></i>
      </div>
      <div style="width: 95px">
        <div
          class="d-flex py-2 justify-content-center px-0 space-nowrap"
          data-testid="datepicker-date"
        >
          {{ date | date: 'EEE dd MMM' }}
        </div>
      </div>
      <div
        class="d-flex px-2 px-sm-1 arrow up m-auto"
        (click)="incrementDate()"
      >
        <i class="fas fa-chevron-right theme-color-header"></i>
      </div>
    </div>
  </div>
</div>
